module.exports = __webpack_public_path__ + "static/media/home.c844cf86.svg";